<lib-curved-box [id]="slice.sectionId" class="margin-on-scroll">
  <div class="container">
    <div class="flex flex-col mx-7 my-8">
      <div data-source="prismic" class="mx-4 text-white text-center mb-9" [innerHtml]="slice.title"></div>
      <div class="flex flex-wrap justify-center mb-6 lg:mb-14">
        @for (item of slice.items; track item) {
          <div class="flex flex-col items-center w-2/6 p-2 lg:p-4 xl:p-12">
            @if (item.icon) {
              <img [src]="item.icon.url" [alt]="item.icon.alt" class="text-white" width="96" height="96" />
            }
            <div data-source="prismic" class="text-white text-center" [innerHtml]="item.title"></div>
            <ngx-dynamic-hooks
              data-source="prismic"
              [content]="item.description"
              [options]="{ sanitize: false }"
              class="hidden lg:block text-white text-center"
            >
            </ngx-dynamic-hooks>
          </div>
        }
      </div>
      @if (slice.button_link && slice.button_link.toString() !== '' && slice.button_text) {
        <lib-link class="self-center" [link]="slice.button_link">
          <div
            data-source="prismic"
            class="w-60 button button-transparent text-center font-bold"
            [innerHtml]="slice.button_text"
          ></div>
        </lib-link>
      }
    </div>
  </div>
</lib-curved-box>
